import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import { useParams } from 'react-router';
import SelectProfile from 'react-select';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { useLocation } from 'react-router';
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const CreateRiskManagementPlanComp = (props) => {
  const routeParams = useParams();
  console.log(routeParams);

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [listRiskProfile, setlistRiskProfile] = useState('');
  const [idRiskProfile, setidRiskProfile] = useState('');
  const [riskManagement, setriskManagement] = useState('');
  const [existingControl, setexistingControl] = useState('');

  const [isEffective, setisEffective] = useState('');
  const [alternativeRiskManagement, setalternativeRiskManagement] =
    useState('');
  const [action, setaction] = useState('');
  const [deadline, setdeadline] = useState('');
  const [type, settype] = useState('');
  const [pic, setpic] = useState('');

  const location = useLocation();
  const [role, setRole] = useState('');

  const fetchlistByFk = async () => {
    try {
      const options = {
        url: `/risk-profile/showByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setlistRiskProfile([]);
      data.map((d) =>
        setlistRiskProfile((listRiskProfile) => [
          ...listRiskProfile,
          {
            label: d.rank,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-management-plan/create.fetchlistByFk');
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-management-plan/create.fetchOneUser');
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-management-plan/create.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchlistByFk();
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  const handleChangeProfile = async (row) => {
    try {
      const options = {
        url: `/risk-profile/show/${row.value}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;

      setidRiskProfile(row);
      setriskManagement(data?.risk_register?.riskManagement);
      setexistingControl(data?.risk_register?.existingControl);
    } catch (err) {
      setLoading(false);
      notifyApiLoadError(err, 'components/moleculs/risk-management-plan/create.handleChangeProfile');
    }
  };

  const handleCreateRiskManagementPlan = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idRiskProfile: idRiskProfile?.value,
      isEffective: isEffective,
      alternativeRiskManagement: alternativeRiskManagement,
      action: action,
      deadline: deadline,
      type: type,
      pic: pic,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: '/management-plan/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully tambah laporan!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <div>
      <div className="row">
        <h4>Risk Register</h4>
        <hr className="my-2" />
      </div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="riskManagement" className="form-label">
              Uraian Penanganan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="riskManagement"
              disabled
              value={riskManagement}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="existingControl" className="form-label">
              Pengendalian yang sudah ada
            </label>
            <textarea
              className="form-control row-cols-3"
              id="existingControl"
              disabled
              value={existingControl}
            ></textarea>
          </div>
        </div>
        <hr className="my-2" />
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="name" className="form-label required">
              Ranking Risk Profil
            </label>
            <SelectProfile
              id="name"
              value={idRiskProfile}
              onChange={handleChangeProfile}
              options={listRiskProfile}
              placeholder="Cari ranking"
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="type" className="form-label required">
              Jenis (Detektif (D), Preventif (P), Korektif (K))
            </label>
            <select
              className="form-select"
              id="type"
              onChange={(e) => settype(e.target.value)}
            >
              <option selected disabled>
                Pilih
              </option>
              <option value={'Detektif (D)'}>Detektif (D)</option>
              <option value={'Preventif (P)'}>Preventif (P)</option>
              <option value={'Korektif (K)'}>Korektif (K)</option>
            </select>
          </div>
        </div>
        {/* <div className="col-6">
          <div className="mb-5">
            <label htmlFor="isEffective" className="form-label required">
              Tingkat Efektifitas
            </label>
            <select
              className="form-select"
              id="isEffective"
              onChange={(e) => setisEffective(e.target.value)}
            >
              <option selected disabled>
                Pilih
              </option>
              <option value={'Efektif'}>Efektif</option>
              <option value={'Kurang Efektif'}>Kurang Efektif</option>
              <option value={'Tidak Efektif'}>Tidak Efektif</option>
            </select>
          </div>
        </div> */}
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="action" className="form-label required">
              Pengendalian yang harus ada
            </label>
            <textarea
              className="form-control row-cols-3"
              id="action"
              onChange={(e) => setaction(e.target.value)}
              value={action}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="alternativeRiskManagement"
              className="form-label required"
            >
              Kegiatan Rencana Pengendalian
            </label>
            <textarea
              className="form-control row-cols-3"
              id="alternativeRiskManagement"
              onChange={(e) => setalternativeRiskManagement(e.target.value)}
              value={alternativeRiskManagement}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="deadline" className="form-label required">
              Tanggal Deadline
            </label>
            <input
              type="date"
              className="form-control row-cols-3"
              id="deadline"
              onChange={(e) => setdeadline(e.target.value)}
              value={deadline}
            ></input>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="pic" className="form-label required">
              Penanggung Jawab TL Pengendalian
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="pic"
              onChange={(e) => setpic(e.target.value)}
              value={pic}
              autoComplete="off"
            ></input>
          </div>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleCreateRiskManagementPlan()}
          >
            <IconDeviceFloppy stroke={2} />{' '}
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateRiskManagementPlanComp;
